import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fc7b6444"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "practice-wrapper" }
const _hoisted_2 = {
  class: "control",
  title: "Toggle options menu"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-left" })
], -1))
const _hoisted_4 = {
  key: 0,
  class: "text"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "heading-text" }, "Practice details")
], -1))
const _hoisted_8 = { class: "info-box" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Practice ID", -1))
const _hoisted_10 = { class: "fielddata" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Practice Name", -1))
const _hoisted_12 = { class: "fielddata" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Branch ID", -1))
const _hoisted_14 = { class: "fielddata" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Branch address", -1))
const _hoisted_16 = { class: "fielddata" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Business phone", -1))
const _hoisted_18 = { class: "fielddata" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Email", -1))
const _hoisted_20 = { class: "fielddata" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Website", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Starting date", -1))
const _hoisted_23 = { class: "fielddata" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Practice type", -1))
const _hoisted_25 = { class: "fielddata" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"border":"1px solid #394F5A","margin":"25px 0"} }, null, -1))
const _hoisted_27 = { class: "heading" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "heading-text" }, "Status", -1))
const _hoisted_29 = { class: "info-box" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Trust account status", -1))
const _hoisted_31 = {
  key: 0,
  class: "fielddata"
}
const _hoisted_32 = { class: "select-wrapper" }
const _hoisted_33 = { class: "sml-select" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  disabled: ""
}, "-- Select status --", -1))
const _hoisted_35 = ["value"]
const _hoisted_36 = {
  key: 1,
  class: "fielddata"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Practice status", -1))
const _hoisted_38 = { class: "fielddata" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Date of disposal", -1))
const _hoisted_41 = { class: "fielddata" }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Disposal reason", -1))
const _hoisted_44 = { class: "fielddata" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Priority", -1))
const _hoisted_46 = {
  key: 0,
  class: "fielddata"
}
const _hoisted_47 = { class: "select-wrapper" }
const _hoisted_48 = { class: "sml-select" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "-- Select priority --", -1))
const _hoisted_50 = ["value"]
const _hoisted_51 = {
  key: 1,
  class: "fielddata"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"border":"1px solid #394F5A","margin":"25px 0"} }, null, -1))
const _hoisted_53 = { class: "heading" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "heading-text" }, "Accounting details", -1))
const _hoisted_55 = { key: 2 }
const _hoisted_56 = ["disabled"]
const _hoisted_57 = { class: "info-box" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Name of bookkeeper *", -1))
const _hoisted_59 = {
  key: 0,
  class: "fielddata"
}
const _hoisted_60 = { class: "input-box" }
const _hoisted_61 = {
  key: 1,
  class: "fielddata"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Inspect results discussed with *", -1))
const _hoisted_63 = {
  key: 0,
  class: "fielddata"
}
const _hoisted_64 = { class: "input-box" }
const _hoisted_65 = {
  key: 1,
  class: "fielddata"
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Re-inspection period *", -1))
const _hoisted_67 = {
  key: 0,
  class: "fielddata"
}
const _hoisted_68 = { class: "select-wrapper" }
const _hoisted_69 = { class: "sml-select" }
const _hoisted_70 = /*#__PURE__*/_createStaticVNode("<option value=\"null\" disabled data-v-fc7b6444>--Select period--</option><option value=\"3\" data-v-fc7b6444>3 months</option><option value=\"6\" data-v-fc7b6444>6 months</option><option value=\"9\" data-v-fc7b6444>9 months</option><option value=\"12\" data-v-fc7b6444>12 months</option><option value=\"18\" data-v-fc7b6444>18 months</option><option value=\"24\" data-v-fc7b6444>24 months</option>", 7)
const _hoisted_77 = [
  _hoisted_70
]
const _hoisted_78 = {
  key: 1,
  class: "fielddata"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Re-inspection date", -1))
const _hoisted_80 = { class: "fielddata" }
const _hoisted_81 = { class: "EE-section" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"border":"1px solid #394F5A","margin":"25px 0"} }, null, -1))
const _hoisted_83 = { class: "heading" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "heading-text" }, "External Examiner", -1))
const _hoisted_85 = { class: "info-box" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Name", -1))
const _hoisted_87 = { class: "fielddata" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Phone number", -1))
const _hoisted_89 = { class: "fielddata" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Email", -1))
const _hoisted_91 = { class: "fielddata" }
const _hoisted_92 = { class: "additional-contact" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"border":"1px solid #394F5A","margin":"25px 0"} }, null, -1))
const _hoisted_94 = { class: "heading" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "heading-text" }, "Additional contact", -1))
const _hoisted_96 = { key: 2 }
const _hoisted_97 = ["disabled"]
const _hoisted_98 = { class: "info-box" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Contact 1 Name", -1))
const _hoisted_100 = {
  key: 0,
  class: "fielddata"
}
const _hoisted_101 = { class: "input-box" }
const _hoisted_102 = {
  key: 1,
  class: "fielddata"
}
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Contact 1 Email", -1))
const _hoisted_104 = {
  key: 0,
  class: "fielddata"
}
const _hoisted_105 = { class: "input-box" }
const _hoisted_106 = {
  key: 1,
  class: "fielddata"
}
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Contact 1 Phone number", -1))
const _hoisted_108 = {
  key: 0,
  class: "fielddata"
}
const _hoisted_109 = { class: "input-box" }
const _hoisted_110 = {
  key: 1,
  class: "fielddata"
}
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Contact 2 Name", -1))
const _hoisted_112 = {
  key: 0,
  class: "fielddata"
}
const _hoisted_113 = { class: "input-box" }
const _hoisted_114 = {
  key: 1,
  class: "fielddata"
}
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Contact 2 Email", -1))
const _hoisted_116 = {
  key: 0,
  class: "fielddata"
}
const _hoisted_117 = { class: "input-box" }
const _hoisted_118 = {
  key: 1,
  class: "fielddata"
}
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Contact 2 Phone number", -1))
const _hoisted_120 = {
  key: 0,
  class: "fielddata"
}
const _hoisted_121 = { class: "input-box" }
const _hoisted_122 = {
  key: 1,
  class: "fielddata"
}
const _hoisted_123 = { class: "right-panel" }

export function render(_ctx, _cache) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_router_view = _resolveComponent("router-view")
  const _component_AppointEeModal = _resolveComponent("AppointEeModal")
  const _component_ConfirmDialogue = _resolveComponent("ConfirmDialogue")

  return (_openBlock(), _createElementBlock("section", null, [
    (_ctx.loadingContent)
      ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: _normalizeClass(['left-panel', _ctx.hidePracticeInfo ? 'hideInfo': ''])
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: "hide-options",
                  onClick: _cache[0] || (_cache[0] = $event => (_ctx.showHideOptions(_ctx.hideLeftPanel)))
                }, [
                  _hoisted_3,
                  (!_ctx.hidePracticeInfo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Hide Options"))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.hideLeftPanel)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "show-options",
                      onClick: _cache[1] || (_cache[1] = $event => (_ctx.showHideOptions(_ctx.hideLeftPanel)))
                    }, [
                      _createTextVNode(" Show"),
                      _hoisted_5,
                      _createTextVNode("Options ")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (!_ctx.hidePracticeInfo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", null, [
                        _hoisted_9,
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.selectedPractice.firmId), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_11,
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.selectedPractice.branchId == null ? _ctx.selectedPractice.name :
                _ctx.selectedPractice.name
                + ' - ' + _ctx.selectedPractice.tradingName), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_13,
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.selectedPractice.branchId ?? '-'), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_15,
                        _createElementVNode("span", _hoisted_16, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.selectedPractice.address), 1)
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_17,
                        _createElementVNode("span", _hoisted_18, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.selectedPractice.branchId ? _ctx.selectedPractice.branchBusinessPhone :
                  _ctx.selectedPractice.firmBusinessPhone), 1)
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_19,
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.selectedPractice.email ?? '-'), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_21,
                        (_ctx.selectedPractice.website)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "fielddata link2",
                              onClick: _cache[2] || (_cache[2] = $event => (_ctx.openExternalURL(_ctx.selectedPractice.website)))
                            }, _toDisplayString(_ctx.selectedPractice.website), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_22,
                        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$formatDate(_ctx.selectedPractice.effectiveStartDate)), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_24,
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.selectedPractice.firmTypeDescription ?? '-'), 1)
                      ])
                    ]),
                    _hoisted_26,
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      (_ctx.savingPracticeStatus)
                        ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                            key: 0,
                            showLoadingText: false
                          }))
                        : (!_ctx.editingPracticeStatus && !_ctx.savingPracticeStatus)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "btn btn-outline dark sml",
                              onClick: _cache[3] || (_cache[3] = $event => (_ctx.editingPracticeStatus = !_ctx.editingPracticeStatus))
                            }, "Edit"))
                          : (_ctx.editingPracticeStatus && !_ctx.savingPracticeStatus)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                class: "btn btn-primary sml",
                                onClick: _cache[4] || (_cache[4] = $event => {_ctx.savePracticeDetails();})
                              }, "Save"))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", null, [
                        _hoisted_30,
                        (_ctx.editingPracticeStatus)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, [
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.practiceStatusForm.trustAccountStatusId) = $event))
                                  }, [
                                    _hoisted_34,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trustAccountStatus, (ta) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        value: ta.id
                                      }, _toDisplayString(ta.name), 9, _hoisted_35))
                                    }), 256))
                                  ], 512), [
                                    [_vModelSelect, _ctx.practiceStatusForm.trustAccountStatusId]
                                  ])
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.selectedPractice.trustAccountStatus?.name), 1))
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_37,
                        _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.selectedPractice.statusDescription), 1)
                      ]),
                      (_ctx.selectedPractice.effectiveEndDate)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _hoisted_40,
                            _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$formatDate(_ctx.selectedPractice.effectiveEndDate)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.selectedPractice.effectiveEndDate)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _hoisted_43,
                            _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.selectedPractice.disposalCodeDescription), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        _hoisted_45,
                        (_ctx.editingPracticeStatus)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_46, [
                              _createElementVNode("div", _hoisted_47, [
                                _createElementVNode("div", _hoisted_48, [
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.practiceStatusForm.priorityId) = $event))
                                  }, [
                                    _hoisted_49,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.priorities, (p) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        value: p.id
                                      }, _toDisplayString(p.name), 9, _hoisted_50))
                                    }), 256))
                                  ], 512), [
                                    [_vModelSelect, _ctx.practiceStatusForm.priorityId]
                                  ])
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_ctx.selectedPractice.priority?.name), 1))
                      ])
                    ]),
                    _hoisted_52,
                    _createElementVNode("div", _hoisted_53, [
                      _hoisted_54,
                      (_ctx.savingAccountingDetails)
                        ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                            key: 0,
                            showLoadingText: false
                          }))
                        : (!_ctx.editingAccountingDetails && !_ctx.savingAccountingDetails)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "btn btn-outline dark sml",
                              onClick: _cache[7] || (_cache[7] = $event => (_ctx.editingAccountingDetails = !_ctx.editingAccountingDetails))
                            }, "Edit"))
                          : (_ctx.editingAccountingDetails && !_ctx.savingAccountingDetails)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                _createElementVNode("button", {
                                  class: "btn btn-default sml",
                                  onClick: _cache[8] || (_cache[8] = $event => {_ctx.cancelEditAccountingDetails();})
                                }, "Cancel"),
                                _createElementVNode("button", {
                                  class: "btn btn-primary sml ml-1",
                                  onClick: _cache[9] || (_cache[9] = $event => {_ctx.saveAccountingDetails();}),
                                  disabled: !_ctx.canSaveAccountingDetails
                                }, "Save", 8, _hoisted_56)
                              ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", null, [
                        _hoisted_58,
                        (_ctx.editingAccountingDetails)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_59, [
                              _createElementVNode("div", _hoisted_60, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.practiceAccountingDetailsForm.bookkeeper) = $event)),
                                  maxlength: "200",
                                  onKeyup: _cache[11] || (_cache[11] = $event => (_ctx.checkAccountingDetails()))
                                }, null, 544), [
                                  [_vModelText, _ctx.practiceAccountingDetailsForm.bookkeeper]
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(_ctx.selectedPractice.bookkeeper ?? '-'), 1))
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_62,
                        (_ctx.editingAccountingDetails)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_63, [
                              _createElementVNode("div", _hoisted_64, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((_ctx.practiceAccountingDetailsForm.inspectResultsDiscussedWith) = $event)),
                                  maxlength: "200",
                                  onKeyup: _cache[13] || (_cache[13] = $event => (_ctx.checkAccountingDetails()))
                                }, null, 544), [
                                  [_vModelText, _ctx.practiceAccountingDetailsForm.inspectResultsDiscussedWith]
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString(_ctx.selectedPractice.inspectResultsDiscussedWith ?? '-'), 1))
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_66,
                        (_ctx.editingAccountingDetails)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_67, [
                              _createElementVNode("div", _hoisted_68, [
                                _createElementVNode("div", _hoisted_69, [
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ((_ctx.practiceAccountingDetailsForm.reInspectionPeriodInMonths) = $event)),
                                    onChange: _cache[15] || (_cache[15] = $event => (_ctx.checkAccountingDetails()))
                                  }, _hoisted_77, 544), [
                                    [_vModelSelect, _ctx.practiceAccountingDetailsForm.reInspectionPeriodInMonths]
                                  ])
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_78, _toDisplayString(_ctx.selectedPractice.reInspectionPeriodInMonths ?
                _ctx.selectedPractice.reInspectionPeriodInMonths + ' months' : '-'), 1))
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_79,
                        _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.selectedPractice.reInspectionDate ?
                _ctx.$formatDate(_ctx.selectedPractice.reInspectionDate)
                : '-'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_81, [
                      _hoisted_82,
                      _createElementVNode("div", _hoisted_83, [
                        _hoisted_84,
                        (_ctx.loadingEE)
                          ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                              key: 0,
                              showLoadingText: false
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.selectedEE)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "btn btn-outline dark sml",
                              onClick: _cache[16] || (_cache[16] = $event => (_ctx.addEditingEE()))
                            }, "Edit"))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              class: "btn btn-outline dark sml",
                              onClick: _cache[17] || (_cache[17] = $event => (_ctx.addEditingEE()))
                            }, "Appoint"))
                      ]),
                      _createElementVNode("div", _hoisted_85, [
                        _createElementVNode("div", null, [
                          _hoisted_86,
                          _createElementVNode("span", _hoisted_87, _toDisplayString(_ctx.selectedEE?.firstName) + " " + _toDisplayString(_ctx.selectedEE?.lastName ?? '-'), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_88,
                          _createElementVNode("span", _hoisted_89, _toDisplayString(_ctx.selectedEE?.phoneDetail?.countryCode) + " " + _toDisplayString(_ctx.selectedEE?.phoneDetail?.phoneNumber ?? '-'), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_90,
                          _createElementVNode("span", _hoisted_91, _toDisplayString(_ctx.selectedEE?.email ?? '-'), 1)
                        ]),
                        _createElementVNode("div", null, [
                          (_ctx.selectedEE)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-outline dark sml mt-2",
                                style: {"width":"100%"},
                                onClick: _cache[18] || (_cache[18] = $event => (_ctx.deleteEE(_ctx.selectedPractice, _ctx.selectedEE)))
                              }, "Terminate External Examiner"))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_92, [
                      _hoisted_93,
                      _createElementVNode("div", _hoisted_94, [
                        _hoisted_95,
                        (_ctx.loadingAdditionalContacts)
                          ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                              key: 0,
                              showLoadingText: false
                            }))
                          : (!_ctx.editingAdditionalContacts)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "btn btn-outline dark sml",
                                onClick: _cache[19] || (_cache[19] = $event => (_ctx.editAdditionalContact()))
                              }, "Edit"))
                            : (_ctx.editingAdditionalContacts)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                  _createElementVNode("button", {
                                    class: "btn btn-default sml",
                                    onClick: _cache[20] || (_cache[20] = $event => {_ctx.cancelEditAdditionalContacts();})
                                  }, "Cancel"),
                                  _createElementVNode("button", {
                                    class: "btn btn-primary sml ml-1",
                                    onClick: _cache[21] || (_cache[21] = $event => {_ctx.saveAdditionalContacts();}),
                                    disabled: _ctx.loadingAdditionalContacts
                                  }, "Save", 8, _hoisted_97)
                                ]))
                              : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_98, [
                        _createElementVNode("div", null, [
                          _hoisted_99,
                          (_ctx.editingAdditionalContacts)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_100, [
                                _createElementVNode("div", _hoisted_101, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => ((_ctx.selectedAdditionalContact.name1) = $event)),
                                    maxlength: "200"
                                  }, null, 512), [
                                    [_vModelText, _ctx.selectedAdditionalContact.name1]
                                  ])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_102, _toDisplayString(_ctx.selectedAdditionalContact?.name1 ?? '-'), 1))
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_103,
                          (_ctx.editingAdditionalContacts)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_104, [
                                _createElementVNode("div", _hoisted_105, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => ((_ctx.selectedAdditionalContact.email1) = $event)),
                                    maxlength: "200"
                                  }, null, 512), [
                                    [_vModelText, _ctx.selectedAdditionalContact.email1]
                                  ])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_106, _toDisplayString(_ctx.selectedAdditionalContact?.email1 ?? '-'), 1))
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_107,
                          (_ctx.editingAdditionalContacts)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_108, [
                                _createElementVNode("div", _hoisted_109, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => ((_ctx.selectedAdditionalContact.phoneNumber1) = $event)),
                                    maxlength: "200"
                                  }, null, 512), [
                                    [_vModelText, _ctx.selectedAdditionalContact.phoneNumber1]
                                  ])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_110, _toDisplayString(_ctx.selectedAdditionalContact?.phoneNumber1 ?? '-'), 1))
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_111,
                          (_ctx.editingAdditionalContacts)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_112, [
                                _createElementVNode("div", _hoisted_113, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => ((_ctx.selectedAdditionalContact.name2) = $event)),
                                    maxlength: "200"
                                  }, null, 512), [
                                    [_vModelText, _ctx.selectedAdditionalContact.name2]
                                  ])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_114, _toDisplayString(_ctx.selectedAdditionalContact?.name2 ?? '-'), 1))
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_115,
                          (_ctx.editingAdditionalContacts)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_116, [
                                _createElementVNode("div", _hoisted_117, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => ((_ctx.selectedAdditionalContact.email2) = $event)),
                                    maxlength: "200"
                                  }, null, 512), [
                                    [_vModelText, _ctx.selectedAdditionalContact.email2]
                                  ])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_118, _toDisplayString(_ctx.selectedAdditionalContact?.email2 ?? '-'), 1))
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_119,
                          (_ctx.editingAdditionalContacts)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_120, [
                                _createElementVNode("div", _hoisted_121, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => ((_ctx.selectedAdditionalContact.phoneNumber2) = $event)),
                                    maxlength: "200"
                                  }, null, 512), [
                                    [_vModelText, _ctx.selectedAdditionalContact.phoneNumber2]
                                  ])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_122, _toDisplayString(_ctx.selectedAdditionalContact?.phoneNumber2 ?? '-'), 1))
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", _hoisted_123, [
              _createVNode(_component_router_view)
            ])
          ]),
          (_ctx.showAppointEE)
            ? (_openBlock(), _createBlock(_component_AppointEeModal, {
                key: 0,
                practice: _ctx.selectedPractice,
                onUpdate: _cache[28] || (_cache[28] = $event => (_ctx.loadEE(_ctx.selectedPractice.id))),
                onClose: _cache[29] || (_cache[29] = $event => (_ctx.showAppointEE = false))
              }, null, 8, ["practice"]))
            : _createCommentVNode("", true)
        ], 64)),
    _createVNode(_component_ConfirmDialogue, {
      ref: "confirmTerminateDialogue",
      modalOpened: true
    }, null, 512)
  ]))
}